<template>
    <div class="homecontainer container-fluid no-gutters w-container">
        <!-- 头部 -->
        <div class="row row-grid align-items-center">
            <div class="text-center">
                <!-- Image -->
                <figure class="w-100">
                    <img alt="Image placeholder" src="../assets/img/master/master-top.jpg" class="img-fluid">
                </figure>
            </div>
        </div>

        <div class="list">
            <div class="item">
                <div class="img-one" @click="handleOneClick"><img src="../assets/img/master/mater-one.jpg" alt="" ></div>
                <div class="content">
                    <div>
                        本心(原名王荣),是“雍荣·草木本心”艺术玉雕/雕塑品牌的创始人,同时也是“汉泽西”玉雕艺术珍饰的发起者与践行者。她在中国玉雕艺术界拥有举足轻重的地位,是中国宋庄·大洲玉文化创意园专家委员会的重要成员。<br><br>
                        在职业生涯的早期,本心曾在文化行业担任资深职业经理人,积累了丰富的行业经验和资源。她曾担任TREE国际艺术中心总裁,期间策划并成功实施了“会走的树”大型艺术家行走写生巡展活动,这一活动不仅展示了众多  
                    </div>
                     <!-- <div>是非成败转头空，青山依旧在，惯看秋月春风。一壶浊酒喜相逢，古今多少事，滚滚长江东逝水，浪花淘尽英雄。几度夕阳红。白发渔樵江渚上，都付笑谈中。</div>   
                    <div>滚滚长江东逝水，浪花淘尽英雄。是非成败转头空，青山依旧在，几度夕阳红。白发渔樵江渚上，惯看秋月春风。一壶浊酒喜相逢，古今多少事，都付笑谈中。</div>    
                    <div>是非成败转头空，青山依旧在，惯看秋月春风。一壶浊酒喜相逢，古今多少事，滚滚长江东逝水，浪花淘尽英雄。几度夕阳红。白发渔江渚上，都付笑谈中。</div> -->
                </div>
            </div>
            <div class="item">
                <div class="img-two" @click="handleTwoClick"><img src="../assets/img/master/master-two.jpg" alt="">
                   
                </div>
                <div class="content">曲波、男,1968年生人,许届“中国玉雕大工匠”、国家级高级/一级技师、北京市工艺美术大师、河南省工艺美术大师、河南省玉石雕刻大师、河北省工美行业艺术大师、中国玉文化研究会玉雕专业委员会常务副秘书长、中国工艺美术协会玻璃艺术委员会委员、河南省珠宝玉石首饰行业协会常务理事、沈丘玉文化商业联合会副会长。多年来创作出众多优秀玉雕翡梨作品,深受业内人士及藏</div>
            </div>
            <div class="item">
                <div class="img-three" @click="handleThreeClick"><img src="../assets/img/master/master-three.jpg" alt="">
                  
                </div>
                <div class="content">
                    <div>·北京花丝金工坊文化发展有限公司;</div>
                    <div>·1971年开始进入北京工艺美术品总公司花丝镶嵌厂;</div>
                    <div>·1993年开创个人工作室--花丝金工坊,专研中式珠宝的创作;</div>
                    <div>·2015年9月,被聘为北京市故宫文化产品开发有限公司非物质文化遗产研发专业顾问:</div>
                    <div>·2018年10月受台湾珠宝金工协会邀消赴台开办花丝金工技艺训练营活动,并在台南高雄科技大学、台中朝阳科技大学、台北艺术大学进行了三场学术演讲;</div>
              </div>
           
                  
            </div>
            <div class="item">
                <div class="img-four">
                    <img  src="../assets/img/master/master-four.jpg" alt=""  @click="handleFourClick">
                </div>
                <div class="content">
                    <div>
                        辛玉晨,是中国当代备受瞩目的玉雕大师,以其非凡的艺术才华和对玉雕艺术的深刻理解,在业界树立了独特的标杆。辛玉晨的作品在国际国内玉雕艺术领域均享有极高的评价和影响力。<br><br>

对玉石抱有浓厚兴趣与敬畏之心的辛玉晨,通过多年的刻苦钻研与实践,逐渐在玉雕艺术领域崭露头角。他擅长从自然万物与人文历史中汲取灵感,将传统玉雕技艺与现代设计理念相融合,创造出既蕴含深厚文化底蕴又不 
                    </div>
                    <!-- <div>是非成败转头空，青山依旧在，惯看秋月春风。一壶浊酒喜相逢，古今多少事，滚滚长江东逝水，浪花淘尽英雄。几度夕阳红。白发渔樵江渚上，都付笑谈中。</div>   
                    <div>滚滚长江东逝水，浪花淘尽英雄。是非成败转头空，青山依旧在，几度夕阳红。白发渔樵江渚上，惯看秋月春风。一壶浊酒喜相逢，古今多少事，都付笑谈中。</div>    
                    <div>是非成败转头空，青山依旧在，惯看秋月春风。一壶浊酒喜相逢，古今多少事，滚滚长江东逝水，浪花淘尽英雄。几度夕阳红。白发渔江渚上，都付笑谈中。</div> -->
                </div>
            </div>
        </div>



    </div>
</template>

<script>
import { Toast } from 'bootstrap';

export default {
    name: 'Master',
    data() {
        return{ 

        }
    },
    methods:{
        handleOneClick(){
            this.$router.push({name:"MasterDetail",params:{position:1}})
            
        },
        handleTwoClick(){
            this.$router.push({name:"MasterDetail",params:{position:2}})
        },
        handleThreeClick(){
            this.$router.push({name:"MasterDetail",params:{position:3}})
        },
        handleFourClick(){
            this.$router.push({name:"MasterDetail",params:{position:4}})
        }


    }
}



</script>

<style>
.w-container{
    background-color: white;
}
.img-fluid {
    max-width: 100%;
    height: auto;
}

.w-100 {
    width: 100% !important;
}
.list {
            position: relative;
            width: 100%;
            max-width: 1400px;
            /* height: 800px; */
            background-color: white;
            margin: 10px auto;
            box-sizing: border-box;
            padding: 20px 5% ;
        }
        
        .item {
            /* height: 160px; */
            min-height: 180px;
            padding-top: 30px;
            padding-bottom: 50px;
            position: relative;
        }
        
        .list .item:nth-child(2n-1) {
            padding-left: 200px;
            box-sizing: border-box;
            width: 100%;
        }
        
        .list .item:nth-child(2n) {
            padding-right: 200px;
            box-sizing: border-box;
            width: 100%;
        }
        
       
       
        .img-one {
            position: absolute;
            top: 20px;
            width: 160px;
            height: 160px;
            border-radius: 160px;
            overflow: hidden;
        }
        .img-one img {
            width: 160px;
            height: 160px;
        }

        .list .item:nth-child(2n-1) .img-one {
            left: 0;
        }

        .img-two {
            position: absolute;
            top: 20px;
            width: 160px;
            height: 160px;
            border-radius: 160px;
            overflow: hidden;
        }
        .img-two img {
            width: 160px;
            height: 160px;
        }

        .list .item:nth-child(2n) .img-two {
            right: 0;
        }

        .img-three {
            position: absolute;
            top: 20px;
            width: 160px;
            height: 160px;
            border-radius: 160px;
            overflow: hidden;
        }
        .img-three img {
            width: 160px;
            height: 160px;
        }

        .list .item:nth-child(2n-1) .img-three {
            left: 0;
        }

        .img-four {
            position: absolute;
            top: 20px;
            width: 160px;
            height: 160px;
            border-radius: 160px;
            overflow: hidden;
        }
        .img-four img {
            width: 160px;
            height: 160px;
        }

        .list .item:nth-child(2n) .img-four {
            right: 0;
        }
       


     
        
        .content {
            width: 100%;
        }
        
    
    
</style>